import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import {
  attachmentCreateGroup,
  attachmentAddAttachmentToGroup,
  attachmentDeleteSingleAttachment,
} from '../redux/features/attachment/attachmentThunk'

const useAttachmentGroup = ({ tag = 'leaves', groupId = null } = {}) => {
  const dispatch = useDispatch()
  const sharedGroupIdRef = useRef(groupId)
  const groupCreationPromiseRef = useRef(groupId)

  const handleAddFile = async (file) => {
    let currentGroupId = sharedGroupIdRef.current

    if (!currentGroupId) {
      if (!groupCreationPromiseRef.current) {
        groupCreationPromiseRef.current = dispatch(
          attachmentCreateGroup({ queries: { tags: tag } }),
        )
      }

      const res = await groupCreationPromiseRef.current
      groupCreationPromiseRef.current = null

      if (res?.meta?.requestStatus !== 'fulfilled') return null

      currentGroupId = res.payload?.id
      sharedGroupIdRef.current = currentGroupId
    }

    if (!currentGroupId) return null

    const formData = new FormData()
    formData.append('file', file)

    try {
      const response = await dispatch(
        attachmentAddAttachmentToGroup({
          groupId: currentGroupId,
          queries: formData,
        }),
      )

      if (response?.meta?.requestStatus === 'fulfilled') {
        return response.payload?.attachment
      }

      return null
    } catch {
      return null
    }
  }

  const handleRemoveFile = async (file) => {
    const response = await dispatch(
      attachmentDeleteSingleAttachment({
        groupId: sharedGroupIdRef.current,
        attachmentId: file?.id,
      }),
    )
    return response?.meta?.requestStatus === 'fulfilled'
  }

  const reset = () => {
    sharedGroupIdRef.current = null
    groupCreationPromiseRef.current = null
  }

  return {
    handleAddFile,
    handleRemoveFile,
    getGroupId: () => sharedGroupIdRef.current,
    reset,
  }
}

export default useAttachmentGroup
